import React from "react";
import { ReactComponent as BuildingIcon } from 'assets/icons/building.svg';
import { ReactComponent as PoliticanIcon } from 'assets/icons/politican.svg';
import { ReactComponent as BriefcaseIcon } from 'assets/icons/briefcase.svg';
import { ReactComponent as FactoryIcon } from 'assets/icons/factory.svg';
import { ReactComponent as MediaAnalyticIcon } from 'assets/icons/media-analytic.svg';
import EchoButton from "pages/landing-page/items/echo-button/echo-button";
import s from "./situable-for.module.scss";

const SituableFor = (props) => {

    const getIconByTitle = (imageText) => {
        switch(imageText){
            case 'GOVERNMENT_BODIES':
                return <BuildingIcon />;
            case 'POLITICAL_AND_PUBLIC_ORGANIZATIONS':
                return <PoliticanIcon />;
            case 'BUSINESS_AND_FINANCE':
                return <BriefcaseIcon />;
            case 'QUASI_PUBLIC_AND_PRIVATE_SECTOR':
                return <FactoryIcon />;
            case 'MEDIA_ANALYTICS_AND_PR':
                return <MediaAnalyticIcon />;
        }
    }

    const showDemoModal = (isShow) => {
        props.setShowDemo()
    }

    const getBlock = (k, index) => {
        return <div className={s.textBlock} key={index}>
                    <div className={s.textHeaderBlock}>
                        <div className={s.iconBlock}>
                            {getIconByTitle(k.title)}
                        </div>
                        <span>
                            <b>{props.getValue(k.title)}</b><span>{props.getValue(k.description)}</span>
                        </span>
                    </div>
                    <div className={s.blockText}>
                        <span>
                            { props.getValue(k.text)}
                        </span>
                    </div>
                </div>
    }

    let rightBlocks = [];
    let LeftBlocks = [];
    props.situableBlocks.forEach((k, i) => {
        if(i < 3){
            LeftBlocks.push(getBlock(k, i));
        }
        else
            rightBlocks.push(getBlock(k, i))
    });
    return (
        <div className={s.SituableFor}>
            <div className={s.SituableContent}>
                <div className={s.leftBlock}>
                    <div className={s.titleBlcok}>
                        <h1>{props.getValue('SITUABLE_FOR')}</h1>
                    </div>
                    <div className={s.blocks}>
                        { LeftBlocks }
                    </div>

                </div>
                <div className={s.rightBlock}>
                    <div className={s.textBlock+" "+s.backround}>
                        <span className={s.centerBlockText} style={{color: '#1A3950'}}>
                        {props.getValue('A_TOOL_FOR_STRATEGIC')}
                        </span>
                    </div>
                    { rightBlocks }
                    <div className={s.textBlock+" "+s.backround}>
                        <EchoButton styles={{width: "300px", height: "54px"}} title={props.getValue('WANT_DEMO_ACCESS')} callback={showDemoModal}/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SituableFor;